import { Container, Button } from "react-bootstrap";

const TrainingRegister = () => {
  return (
    <section className="py-5 text-white">
      <Container className="text-center bg-dark rounded-4 p-5">
        <h2 className="wise-secondary-gradient training-register">
          Register Your Interest
        </h2>
        <p className="mt-3">
          WISE Trainings are launching soon. Register your interest to receive
          priority access.
        </p>
        <Button
          as="a"
          href="https://docs.google.com/forms/d/e/1FAIpQLSdILX6Yb8JnXi8kInhMGRvvxqxEuRcLEg_svvkCoLMqzCUMhw/viewform?usp=publish-editor"
          target="_blank"
          rel="noopener noreferrer"
          variant="primary"
          className="rounded-2"
        >
          Register Your Interest
        </Button>
      </Container>
    </section>
  );
};

export default TrainingRegister;
